import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  layout: {
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
});
